

import { useState, useEffect } from 'react'
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import ButtonAction from "/src/components/UI/Button/Button";
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import DropDown from '/src/components/UI/DropDown/DropDown';
import { useForm, useFieldArray } from "react-hook-form";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import userService from '../../services/userService';
import companyService from "/src/features/administration/company/services/companyService";
import roleService from '../../../role/services/roleService';
import Dropdown from '/src/components/UI/DropDown/DropDown';
import AutoComplete from "/src/components/UI/AutoComplete/AutoComplete";
import "./UserModalBody.css";
import "./UserModal.css"
import FormData from 'form-data';
import Storage from "/src/utils/storage";
import imageChoices from '../../../role/components/RoleForm/roleImages';
function UserModalBodyUser({ data, title }) {
    console.log(data)
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const currentUser = Storage('local').get('user');
    const { register, handleSubmit, formState: { errors }, getValues, setValue, watch } = useForm({
        mode: "onChange",
        defaultValues: {
            id: data ? data.id : "",
            username: data ? data.username : "",
            email: data ? data.email : "",
            image: data ? data.image : "", // form.statementArray,
            company_role: data ? data.role : -1,
        },
    });
    console.log(data)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const { getCompaniesAutocomplete } = companyService;
    const { addUser, updateUser, checkAvaibility } = userService;
    const {getRoles} = roleService;
    const [roles, setRoles] = useState([]);
    const [rolesCompany, setRolesCompany] = useState([]);


    const [userAvailable, setUserAvailable] = useState({ email: true, username: true });
    const [file, setFile] = useState(data?.image);
    const [loadAnim, setLoading] = useState(null);
    const [dataReady, setDataReady] = useState(false);
    const onSubmit = async () => {
        var dataToSend = getValues();
        // console.log('dataToSend', dataToSend);
        const formData = new FormData();
        formData.append('username', dataToSend.username)
        formData.append('email', dataToSend.email)
        formData.append('company_role', dataToSend.company_role)
        formData.append('image', file)

        let [response, error] = data != null ? await updateUser(data.id, formData) : await addUser(formData)
        if (error !== null) {
            console.log(error);
            return;
        }

        modal.resolve(response)
        onClose();
        return;

    };


    const showImage = (role) => {
        const logoChoice = imageChoices.find(choice => choice.value === role.logo);
        if (logoChoice) {
            return <img src={logoChoice.text.props.src} alt={logoChoice.text.props.alt} />;
        } else {
            return <img src={role.avatar} width={24} height={24} alt={role.avatar} />;
        }
    };

    const setUpRoles = (_roles) => {
        const rolesCompany = _roles || [];
        const initialOption = { value: 'undefined', text: 'Choose Role' };
        return [
            initialOption,
            ...rolesCompany.map(role => ({
                value: role.id,
                text:
                    <span style={{ maxWidth: "300px" , textAlign:'center'}}>
                        <div className="roles_content_dropdown"> {showImage(role)} {role.slug}</div>
                    </span>
            }))
        ]
    }


    const getRolesByUser = async () => {
        let [response, error] = await getRoles();
        if (error !== null) {
            console.log(error);
            return;
        }

        setRoles(setUpRoles(response));
    }

    const checkValues = async (title, value) => {
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvaibility(dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = userAvailable;
        res[title] = title == "email" && value.match(emailRegex) === null ? false : response.available
        if (data != null && value === data[title]) {
            res[title] = true
        }
        setUserAvailable({ ...res })
    }


    useEffect(() => {
        async function fetchData() {
            await getRolesByUser();
            setDataReady(true); 
        }
        fetchData();
    }, []);

    console.log(roles)
    return (
        <div>
          {dataReady && (   
            <Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>{title}</Form.Title>
                <Form.Body className="body-editModal-container">
                    
                    <div style={{  marginBottom: '25px', marginTop:'15px' , display: "flex" ,gap:'4rem' }}>
							<Field label="Role" listLabelClassName="titles-input" />
							<div style={{ marginLeft: "5%", marginTop: "2%" }}>
								<Dropdown name="company_role"  {...register('company_role')} setValue={setValue} placeholder='Choose Role' width="250px" ></Dropdown>
							</div>
					</div>
                   
                    {currentUser.id != data?.id &&
                        <div className="separator_section_form_user" />
                    }
                    <div style={{ marginBottom: "15px" }}>
                        <Field label="Username" />
                        <TextInput {...register('username', { required: true, minLength: 1, onChange: (e) => checkValues("username", e.target.value) })} style={{ borderColor: userAvailable.username == false ? 'red' : "" }} className="full-width text_input_user_form" defaultValue={data ? data.username : ""} placeholder="Choose your username" />
                    </div>
                    <div style={{ marginBottom: "15px" }}>
                        <Field label="Email" />
                        <TextInput {...register('email', { required: true, minLength: 1, onChange: (e) => checkValues("email", e.target.value) })} style={{ borderColor: userAvailable.email == false ? 'red' : "" }} className="full-width text_input_user_form" defaultValue={data ? data.email : ""} placeholder="Choose your email" />
                    </div>
                    
                </Form.Body>
                <Form.Buttons>
                    <ButtonAction type="submit" label={data?.id ? "Update" : "Add"} disabled={
                        !(userAvailable.email == true && watch("email").length > 0 && userAvailable.username == true && watch("username").length > 0 && watch("role") != null
                        )} onSubmit={onSubmit}>

                    </ButtonAction>
                </Form.Buttons>
            </Form>
          )}
        </div>

    );
}
export default UserModalBodyUser;